module.exports = __webpack_public_path__ + "img/weather14.55a1b4fa.png";